import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export function isVideo(url) {
  return /\.(mp4|mov|m4a|wav|webm|avi|mkv)(\?.*)?$/i.test(url)
}

//将'HH:mm:ss', 'mm:ss'转为秒数
export function timeToSeconds(timeStr) {
  const time = dayjs(timeStr, ['HH:mm:ss', 'mm:ss'])
  const hours = time.hour()
  const minutes = time.minute()
  const seconds = time.second()
  const totalSeconds = hours * 3600 + minutes * 60 + seconds
  return totalSeconds
}

// 毫秒转HH:MM:SS格式
export function millisecondsToHHMMSS(milliseconds) {
  // 计算总秒数
  let totalSeconds = Math.floor(milliseconds / 1000)

  // 计算小时数
  let hours = Math.floor(totalSeconds / 3600)

  // 计算剩余秒数
  let remainingSeconds = totalSeconds % 3600

  // 计算分钟数
  let minutes = Math.floor(remainingSeconds / 60)

  // 计算最终的秒数
  let seconds = remainingSeconds % 60

  // 格式化输出
  let hoursStr = hours < 10 ? '0' + hours : hours
  let minutesStr = minutes < 10 ? '0' + minutes : minutes
  let secondsStr = seconds < 10 ? '0' + seconds : seconds

  return hoursStr + ':' + minutesStr + ':' + secondsStr
}

//秒转为'HH:mm:ss'
export function secondsToTime(seconds) {
  return dayjs.unix(seconds).utc().format('HH:mm:ss')
}

/**
 * 处理 answer 字符串，将 [[01:20:45,138 --> 01:20:48,164]] 转换为 01:20:45 和 01:20:48 并插入到 div
 * @param {string} answer
 * @returns {string} 处理后的 HTML 字符串
 */
export function formatAnswer(answer) {
  return answer.replace(
    /\[\[(\d{2}:\d{2}:\d{2}),\d+\s*-->\s*(\d{2}:\d{2}:\d{2}),\d+\]\]/g,
    (match, start, end) => {
      return `<span class="video-time-range" data-start="${start}" data-end="${end}">${start} - ${end}</span>`
    }
  )
}

// 获取链接后缀
export function getFileExtension(filename) {
  const parts = filename.split('.')
  return parts.length > 1 ? parts.pop().toLowerCase() : ''
}
// 获取图片宽高
export function getImageDimensions(file) {
  // 创建一个 Promise，用于异步校验
  return new Promise((resolve, reject) => {
    const img = new Image()
    if (file.fileUrl) {
      img.src = file.fileUrl
    } else {
      img.src = URL.createObjectURL(file)
    }
    img.onload = () => {
      URL.revokeObjectURL(img.src) // 释放内存
      resolve({
        width: img.width,
        height: img.height
      })
    }
    img.onerror = () => {
      URL.revokeObjectURL(img.src)
      reject(new Error('图片无效'))
    }
  })
}
// 生成浅色
export function getRandomLightColor() {
  const hue = Math.floor(Math.random() * 360) // 0~359 任意色相
  const saturation = 30 + Math.random() * 40 // 30~70% 柔和不刺眼
  const lightness = 80 + Math.random() * 15 // 80~95% 足够浅
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`
}
